import React from "react";
import { Button } from "react-native";
import { Text, TouchableOpacity, View, Image } from "react-native";

export default class BookCard extends React.Component {
  render() {
    const { img, title, lesson, bg, read, onPress } = this.props;
    return (
      <View
        style={{
          flexDirection: "row",
          backgroundColor: bg,
          paddingLeft: 5,
          marginHorizontal: 20,
          borderRadius: 20,
          alignItems: "center",
          marginTop: 10,
          shadowColor: "black",
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.8,
          shadowRadius: 2,
          elevation: 30,
          width: 330
          // marginLeft: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            backgroundColor: bg,
            paddingLeft: 5,
            marginHorizontal: 20,
            borderRadius: 20,
            alignItems: "center",
            // marginTop: 10,
            marginLeft: 5,
            shadowColor: "black",
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.8,
            shadowRadius: 2,
            elevation: 30,
          }}
        >
          <View
            // onPress={onPress}
            style={{
              flexDirection: "row",
              backgroundColor: bg,
              padding: 15,
              marginHorizontal: 20,
              borderRadius: 20,
              alignItems: "center",
              // marginTop: 10,
              marginLeft: 5,
              shadowColor: "black",
              shadowOffset: { width: 0, height: 1 },
              shadowOpacity: 0.8,
              shadowRadius: 2,
              elevation: 30,
            }}
          >
            <Image source={img} style={{ width: 75, height: 130 }} />

            <View>
              <Text
                style={{
                  color: "#fff",
                  fontFamily: "Raleway_700Bold",
                  fontSize: 13,
                  paddingHorizontal: 10,
                  width: 170,
                }}
              >
                {title}
              </Text>
              <Text
                style={{
                  color: "#fff",
                  fontFamily: "Raleway_700Bold",
                  fontSize: 12,
                  paddingHorizontal: 10,
                }}
              >
                {lesson}
              </Text>
              {read !== "" ? (
                <TouchableOpacity
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    // backgroundColor: "transparent",
                    backgroundColor: "#fff",

                    borderRadius: 20,
                    padding: 5,
                    height: 40,
                    width: 80,
                    margin: 20,
                    marginBottom: 0,
                    borderWidth: 0.5,
                    borderColor: "#190482",
                  }}
                  onPress={() => onPress()}
                >
                  <Text>{read}</Text>
                </TouchableOpacity>
              ) : null}
            </View>
          </View>
        </View>
      </View>
    );
  }
}
